export default {
  hero: {
    title: '关于',
    titleHighlight: '51吃瓜官网',
    subtitle: '全网最新吃瓜入口 · 独家爆料 · 实时追踪',
  },
  brandIntro: {
    title: '品牌介绍',
    paragraph1: '51吃瓜官网成立于2020年，是国内领先的娱乐八卦资讯平台。我们致力于为广大吃瓜群众提供最新、最全、最热门的娱乐八卦资讯，涵盖明星绯闻、综艺内幕、影视动态、网红八卦等各个领域。',
    paragraph2: '我们的编辑团队由资深娱乐记者和自媒体人组成，拥有丰富的行业经验和广泛的人脉资源，确保每一条资讯的真实性和时效性。',
    paragraph3: '截至目前，51吃瓜官网已累计发布超过10,000篇原创八卦资讯，日均访问量突破百万，已成为国内最受欢迎的吃瓜平台之一。',
  },
  reputation: {
    title: '用户口碑',
    subtitle: '听听我们的用户怎么说',
    reviews: [
      {
        name: '吃瓜小王',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20warm%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
        rating: 5,
        content: '每天必刷的网站！更新速度真的快，很多独家爆料都是在这里先看到的，比微博还快。吃瓜党的天堂！',
      },
      {
        name: '八卦研究员',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20intelligent%20look%2C%20modern%20professional%20style%2C%20clean%20background%2C%20warm%20and%20approachable%2C%20editorial%20portrait&width=100&height=100&seq=avatar-02&orientation=squarish',
        rating: 5,
        content: '作为一个资深吃瓜爱好者，51吃瓜官网的资讯质量确实高。内容详实，有图有真相，不是那种标题党。',
      },
      {
        name: '娱乐圈观察家',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20with%20glasses%2C%20thoughtful%20expression%2C%20casual%20elegant%20style%2C%20clean%20background%2C%20editorial%20portrait%2C%20warm%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
        rating: 4,
        content: '内容覆盖面很广，从明星八卦到影视资讯都有。分类清晰，找想吃瓜很方便。希望能增加更多独家深度报道。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '有料要爆？有合作意向？欢迎随时联系我们！',
    email: '电子邮箱',
    emailValue: 'hello@yjpslu.cn',
    wechat: '微信公众号',
    wechatValue: '51吃瓜官网',
    weibo: '官方微博',
    weiboValue: '@51吃瓜官网',
    address: '公司地址',
    addressValue: '上海市浦东新区张江高科技园区',
    formTitle: '给我们留言',
    formName: '姓名',
    formNamePlaceholder: '请输入你的姓名',
    formEmail: '邮箱',
    formEmailPlaceholder: '请输入你的邮箱地址',
    formMessage: '留言内容',
    formMessagePlaceholder: '请输入你想说的话...',
    formSubmit: '发送留言',
    formSuccess: '留言发送成功！我们会尽快回复你。',
    formError: '发送失败，请稍后再试。',
  },
}